import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseModal, Input, BaseModalProps } from '@anytag/shared-atoms';

export interface AddTagModalProps extends BaseModalProps {
  loading?: boolean;
  onAdd: (newHashtag: string) => void;
}

export const AddTagModal = ({ open, loading, onAdd, onClose, ...restProps }: AddTagModalProps) => {
  const { t } = useTranslation();
  const [hashtagValue, setHashtagValue] = useState<string>('');

  useEffect(
    () => () => {
      if (!open && hashtagValue) {
        setHashtagValue('');
      }
    },
    [open, hashtagValue]
  );

  const handleSubmit = () => {
    if (hashtagValue) {
      onAdd(hashtagValue);
    }
  };

  const handlePressEnter = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <BaseModal
      open={open}
      title={t('Dialog.Add Hashtag')}
      description={t('Dialog.Enter the name of the hashtag you wish to add')}
      onClose={onClose}
      footer={{
        cancelButton: { title: t('Button.Cancel'), onClick: onClose },
        submitButton: { title: t('Button.Add'), onClick: () => onAdd(hashtagValue), loading, disabled: !hashtagValue }
      }}
      {...restProps}
    >
      <Input
        value={hashtagValue}
        onKeyPress={handlePressEnter}
        placeholder={t<string>('TextForm.Hashtag')}
        onChange={(e) => setHashtagValue(e.target.value)}
        autoFocus
      />
    </BaseModal>
  );
};
